import React from 'react';
import ConfigService from '../services/ConfigService';
import { useConfig } from '../hooks/useConfig';
import styles from './WhatsNextDisplay.module.scss';

function WhatsNextDisplay(props) {

    let config = useConfig();

    var status = props.shipment.status;
    var onPickedUp = config?.whatsNext?.onPickedUp;
    var onOFD = config?.whatsNext?.onOFD;

    var message = null;

    if (onPickedUp?.enabled === "True" && status === "PickedUp") {
        message = onPickedUp.message;
    } else if (onOFD?.enabled === "True" && (status === "OFD" || status === "OFDOffSchedule")) {
        message = onOFD.message;
    }

    return message ? (
        <React.Fragment>
            <label id="title">What's Next?</label>
            <div className={`${styles.whatsNext}`} >
                <div className={`${styles.icon}`} >
                    <i className={`icon-whats-next`}></i>
                </div>
                <span>
                    {message}
                </span>
            </div>
        </React.Fragment>
        ) : null;
}

export { WhatsNextDisplay };